import React from "react";
import { SECCIONES, NIVEL, anchorId } from "./secciones";

const REQ_LABEL = {
  [NIVEL.OBLIGATORIA]: "Obligatorio",
  [NIVEL.RECOMENDADA]: "Recomendado",
  [NIVEL.OPCIONAL]: "Según el caso",
};

function IndicadorGuardado({ status, savedAt, onRetry }) {
  if (status === "saving") return <span className="cev__saved cev__saved--saving" aria-live="polite">Guardando…</span>;
  if (status === "dirty") return <span className="cev__saved" aria-live="polite">Cambios sin guardar…</span>;
  if (status === "error")
    return (
      <span className="cev__saved cev__saved--error" aria-live="polite">
        No se pudo guardar ·{" "}
        <button type="button" className="cev__btn cev__btn--ghost cev__btn--sm" onClick={onRetry}>
          Reintentar
        </button>
      </span>
    );
  if (status === "saved" && savedAt)
    return (
      <span className="cev__saved" aria-live="polite">
        Guardado {savedAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
      </span>
    );
  return <span className="cev__saved">Se guarda solo</span>;
}

/**
 * Envoltorio de sección: <section> con <h2> real e id (el rail navega por
 * anclas), chip de nivel, indicador de guardado y pie de navegación
 * anterior / siguiente. El pie avisa (ámbar) si la sección tiene pendientes,
 * pero los botones SIEMPRE funcionan.
 */
export default function SeccionCard({
  seccionId,
  avance,
  autosave,
  headerExtra,
  children,
  onNavegar,
  amberFoot,
  amberMsg,
}) {
  const idx = SECCIONES.findIndex((s) => s.id === seccionId);
  const sec = SECCIONES[idx];
  const anterior = SECCIONES[idx - 1];
  const siguiente = SECCIONES[idx + 1];
  const nivel = sec.nivel;

  return (
    <section id={anchorId(seccionId)} className="cev__card" aria-labelledby={`${anchorId(seccionId)}-h`}>
      <div className="cev__chead">
        <h2 id={`${anchorId(seccionId)}-h`}>{sec.titulo}</h2>
        <span className={`cev__req ${nivel === NIVEL.OBLIGATORIA ? "cev__req--ob" : ""}`}>
          {REQ_LABEL[nivel]}
        </span>
        {headerExtra}
        <div className="cev__chead-grow" />
        {autosave && (
          <IndicadorGuardado status={autosave.status} savedAt={autosave.savedAt} onRetry={autosave.retry} />
        )}
      </div>

      <div className="cev__cbody">{children}</div>

      <div className={`cev__cfoot ${amberFoot ? "cev__cfoot--amber" : ""}`}>
        <button type="button" disabled={!anterior} onClick={() => anterior && onNavegar(anterior.id)}>
          {anterior ? `‹ ${anterior.titulo}` : ""}
        </button>
        {amberFoot && amberMsg ? <span className="cev__cfoot-msg">{amberMsg}</span> : <span />}
        <button type="button" disabled={!siguiente} onClick={() => siguiente && onNavegar(siguiente.id)}>
          {siguiente ? `Siguiente: ${siguiente.titulo} ›` : ""}
        </button>
      </div>
    </section>
  );
}
